import { render, staticRenderFns } from "./ProfitStatement.vue?vue&type=template&id=bee49f9c"
import script from "./ProfitStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfitStatement.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProfitStatement.vue?vue&type=style&index=0&id=bee49f9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports